module.exports = __webpack_public_path__ + "img/BnPFullLogo.ea1d0e01.png";